import { VideoStore } from '../video.store';

import { ControlsStrategyType } from './default-controls-strategy';
import {
  ControlsStrategyTypes,
  DefaultControlsStrategy
} from './default-controls-strategy';
import { ConfigStore } from '../config.store';

export class FullScreenControlsStrategy extends DefaultControlsStrategy {
  type: ControlsStrategyType = ControlsStrategyTypes.FULLSCREEN;
  constructor(
    videoStore: VideoStore,
    config: ConfigStore,
    adContext: Record<string, any>
  ) {
    super(videoStore, config, adContext);
  }

  // TODO: Use elapsedTime from store
  shouldDisplayCloseButton(elapsedTime: number): boolean {
    const closeBtnConfig = this.configStore.config.closeBtn;
    return Boolean(
      closeBtnConfig &&
        !super.shouldHideCloseButton() &&
        (closeBtnConfig.forceImmediate ||
          elapsedTime >= closeBtnConfig.displayAfter) &&
        !this.videoStore.isVideoCompleted.value
    );
  }

  // TODO: Use showRecommendation and elapsedTime from store
  shouldDisableCloseButton(
    showRecommendation: boolean,
    elapsedTime: number
  ): boolean {
    const closeBtnConfig = this.configStore.config.closeBtn;
    return Boolean(
      closeBtnConfig &&
        !super.shouldHideCloseButton() &&
        !closeBtnConfig.forceImmediate &&
        !showRecommendation &&
        elapsedTime < closeBtnConfig.displayAfter &&
        !this.videoStore.isVideoCompleted.value
    );
  }
}
